module.exports = ".custom-right-button {\r\n    float: right;\r\n    width: 90px;\r\n  }\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscriptions/plans/subscription-plan-edit/subscription-plan-edit.component.css
// module id = ./src/app/components/subscriptions/plans/subscription-plan-edit/subscription-plan-edit.component.css
// module chunks = main